import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, convertToUTCISOString, getLocalValue, IsSmallScreen, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { IMeeting } from "../../DTO/Dto";
import MeetingDrawyer from "./DrawyerPages/MeetingDrawyer";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const OverViewMeetingContact: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getMeetingPermission;
    const { showMessage } = useSnackbar();
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const dispatch = useDispatch()
    const params = useParams();
    const { id } = params
    const [openF, setOpen] = React.useState(false);
    const [meetingListData, setMeetingListData] = useState<any>([])
    const [resetLoad, setResetLoad] = useState(false)
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [formComponent, setFormComponent] = useState<any>()
    const isMobile = IsSmallScreen();
    const resetTrigger = useSelector((state: any) => state.components?.meetingContactGrid?.resetTrigger);
    useEffect(() => {

        const getMeetings = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('meetings/lead', Method.GET, null, id);
                setMeetingListData(response || []);
            }
            catch (e) {
            }
        }
        if (id) {
            getMeetings();
        }
    }, [resetTrigger])
    useEffect(() => {

        const getMeetings = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('meetings/lead', Method.GET, null, id);
                setMeetingListData(response || []);
            }
            catch (e) {
            }
        }
        if (id) {
            getMeetings();
        }
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Title",
            fieldName: "title",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "meetingType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "startDateTime",
            tooltip: true,
            type: 'dateTime',
            isHide: isMobile
        },
        {
            header: "End",
            fieldName: "endDateTime",
            tooltip: true,
            type: 'dateTime',
            isHide: isMobile
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            const form: any = <MeetingDrawyer
                id={id}
                control={control}
                register={register}
                meetingId={row.id}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

            />
            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
    }
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`meetings`, Method.DELETE, null, id);
        dispatch(resetDataComponent('meetingContactGrid'));
        setResetLoad(true)
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };

    const handlemeetingsData = async (data: any) => {
        try {
            dispatch(storeDataComponent('meetingSubmit', { loading: true }));
            const response: any = await saveData(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('meetingContactGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('meetingContactGrid'));
                setResetLoad(true)
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(true)
        }
        finally {
            dispatch(updateDataComponent('meetingSubmit', { loading: false }));
        }

    }
    const saveData = async (data: IMeeting) => {
        const startDate: any = convertToUTCISOString(data?.startDateTime.toString())
        const endDate: any = convertToUTCISOString(data?.endDateTime.toString())
        const valuesArray = data?.participantIds.map((participant: any) => participant.value);
        const request: IMeeting = {
            title: data?.title || "",
            startDateTime: startDate || "",
            endDateTime: endDate || "",
            hostUserId: getLocalValue(LoacalVariables.UserId),//data?.assignedToUserId || getLocalValue(LoacalVariables.UserId) ,
            leadId: id || "",
            participantIds: valuesArray,
            customReminderTime: data.customReminderTime,
            notes: data?.notes || "",
            dealId: data?.dealId || "",
            meetingType: data?.meetingType || "",
            reminderOption: data?.reminderOption?.toString()

        }

        if (data?.meetingId) {
            const response: any = await callAPI("meetings", Method.PUT, request, data?.meetingId);
            return response
        } else {
            const response: any = await callAPI("meetings", Method.POST, request);
            return response
        }

    }

    const handleDealsClick = () => {

        const form: any = <MeetingDrawyer
            id={id}
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setOpen(false) }}

        />
        setFormComponent(form)
        setTimeout(() => {
            setOpen(true)
        }, 10);
    }

    return (
        <Grid>
            <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
                {view ? <Grid item xs={12}>
                    <WSDataGrid
                        isAccordian={true}
                        id="meetingContactGrid"
                        title="Meetings"
                        data={meetingListData}
                        columns={columns}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleDealsClick}

                    />
                </Grid>
                    : <PermissionDenied />
                }
            </Grid>
            {formComponent && <SwipeableDrawerForm anchor="right" title={'Meetings'}
                openForm={openF}
                formComponent={<form onSubmit={handleSubmit(handlemeetingsData)}>
                    {formComponent}
                </form>}
                onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
            />}
            <ConfirmDialog
                open={open}
                title={title}
                onConfirm={onConfirm}
                onClose={handleClose}
            />
        </Grid>
    );
});
